import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  ChangeTitle,
  toAbsoluteUrl,
  toasterrormsg,
  toastsuccessmsg,
} from "../../helpers/Reusable";
import { getCookie } from "../../helpers/CookieComponent";
import { apiHeader, postData } from "../../helpers/ApiHelper";

import { ToastContainer } from "react-toastify";
import { IoClose, IoDocument } from "react-icons/io5";
import { MdContentCopy } from "react-icons/md";
import * as Yup from "yup";
import { useFormik } from "formik";
import ClipLoader from "react-spinners/ClipLoader";

const onlyIntRegExp = /^[0-9+]+$/;
const onlyAlphabet = /^[A-Za-z][A-Za-z\s]+$/;

// Formik InitialValues
const initialValues = {
  cheque: "",
};

// Fromik Validation Schema
const schema = Yup.object().shape({
  cheque: Yup.string()
    .trim()
    .required("Cheque Number Is Required")
    .matches(onlyIntRegExp, "Cheque Number Is Not Valid"),
});

const ChoosePaymentReadyReferenceTwo = () => {
  ChangeTitle("Payment");
  const navigate = useNavigate();
  const [planDetail, setPlanDetail] = useState({
    item: {
      name: "Excise,Stamp Economic  Substance Regulation,Customs Stamp,Excise Customs,Corporate Tax,Value Added Tax (VAT),International Taxation",
      price: 200,
      type: "Combo",
    },
    paymentDetail: {
      item: 1,
      subTotal: 200,
      GST: 36,
      grandTotal: 236,
    },
  });
  const [promoCode, setPromoCode] = useState("");
  const [isPromoCodeValid, setIsPromoCodeValid] = useState("");
  const [paymentMode, setPaymentMode] = useState("Online");
  const planbillingId = getCookie("rr-planbillingId");
  const currency = getCookie("rr-plan-currency");
  const planType = getCookie("rr-plan-type");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [promoCodeList, setPromoCodeList] = useState([]);
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues,
    validationSchema: schema,
    onSubmit: async (values, { resetForm }) => {
      // setLoading(true);
      // const param = {};
      // const response = await postData("", param, apiHeader(false));
      // if (
      //   String(response?.status) == "200" &&
      //   String(response?.data.status) == "200"
      // ) {
      //   toastsuccessmsg(response.data.message);
      //   setTimeout(() => {
      //     // setLoading(false);
      //     resetForm();
      //   }, 1500);
      // } else {
      //   console.log(response.data.message);
      //   toasterrormsg(response.data.message);
      //   // setLoading(false);
      // }
    },
  });

  // Plan Detail API Call
  // const viewPlanDetail = async (id, type, promoCode, currency) => {
  //   const param = {
  //     planId: id,
  //     type: type,
  //     promoCode: promoCode,
  //     currency: currency || "INR",
  //   };
  //   console.log(param);

  //   var response = await postData(
  //     "private/readyreferenceplanpurchase/preview",
  //     param,
  //     apiHeader(false)
  //   );

  //   console.log(response.data);

  //   if (
  //     String(response?.status) == "200" &&
  //     String(response?.data.status) == "200"
  //   ) {
  //     const message = response.data.message;
  //     const data = response.data.data;
  //     // if (message == "Promo Code is Invalid") {
  //     //   toasterrormsg(message);
  //     //   // setIsPromoCodeValid(message);
  //     // }
  //     if (message != "Success") {
  //       if (message == "Promo Code is Invalid") {
  //         toasterrormsg(message);
  //       } else {
  //         toastsuccessmsg(message);
  //       }
  //     }
  //     setPlanDetail(data);
  //   } else {
  //     console.log(response.data);
  //     console.log(response.data.message);
  //     toasterrormsg(response.data.message);
  //   }
  // };

  // Plan Detail API Call
  const viewPromoCode = async (grandTotal="", currency, discount = "") => {
    const param = {
      offset: 0,
      limit: 0,
      grandTotal: +grandTotal + +discount,
      currency: currency,
    };

    var response = await postData(
      "private/promocode/user/list",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const listData = response.data.data.list;
      setPromoCodeList(listData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  useEffect(() => {
    viewPromoCode(
      planDetail &&
        planDetail.paymentDetail &&
        planDetail.paymentDetail.grandTotal.toFixed(2),
      currency,
      planDetail &&
        planDetail.paymentDetail &&
        planDetail.paymentDetail.discount &&
        planDetail.paymentDetail.discount.toFixed(2)
    );
  }, [
    planDetail &&
      planDetail.paymentDetail &&
      planDetail.paymentDetail.grandTotal.toFixed(2),
    currency,
    planDetail &&
      planDetail.paymentDetail &&
      planDetail.paymentDetail.discount &&
      planDetail.paymentDetail.discount.toFixed(2),
  ]);
  // Purchase Plan Api call
  const addPlanPurchase = async (
    transactionId = "",
    planId,
    price,
    currency,
    paymentType,
    gst,
    grandTotal,
    promoCode = "",
    promoCodeType = "",
    discount = "",
    planType
  ) => {
    // if (!transactionId) {
    //   setLoading(true);
    // }
    const param = {
      transactionId: transactionId,
      planId: planId,
      price: price,
      currency: currency,
      paymentType: paymentType,
      GST: gst,
      grandTotal: grandTotal,
      promoCode: promoCode,
      promoCodeType: promoCodeType,
      discount: discount,
      type: planType,
    };

    // var response = await postData(
    //   "private/readyreferenceplanpurchase/buy",
    //   param,
    //   apiHeader(false)
    // );

    // console.log("plan purchase", response);

    // if (
    //   String(response?.status) == "200" &&
    //   String(response?.data.status) == "200"
    // ) {
    //   if (paymentType == "Online") {
    //     sessionStorage.setItem("paymentstatus", "success");
    //     navigate("/paymentstatus");
    //   } else {
    //     sessionStorage.setItem("paymentstatus", "cashondelivery");
    //     navigate("/paymentstatus");
    //   }
    //   if (!transactionId) {
    //     setTimeout(() => {
    //       setLoading(false);
    //       navigate("/paymentstatus");
    //     }, 2000);
    //   }
    // } else {
    //   setLoading(false);
    //   console.log(response.data);
    //   console.log(response.data.message);
    // }
  };

  // const openCheckout = (
  //   planName,
  //   subTotal,
  //   planbillingId,
  //   currency,
  //   paymentMode,
  //   gst,
  //   grandTotal,
  //   promoCode,
  //   promoCodeType,
  //   discount,
  //   planType
  // ) => {
  //   if (
  //     !planName ||
  //     !subTotal ||
  //     !planbillingId ||
  //     !currency ||
  //     !paymentMode ||
  //     !gst ||
  //     !grandTotal ||
  //     !planType
  //   ) {
  //     return;
  //   }

  //   // Define multipliers for each currency
  //   const currencyMultiplier = {
  //     INR: 100, // Indian Rupee
  //     USD: 100, // US Dollar
  //     BHD: 1000, // Bahraini Dinar
  //     QAR: 100, // Qatari Riyal
  //     OMR: 1000, // Omani Rial
  //     AED: 100, // UAE Dirham
  //   };

  //   // Default to 100 if the currency isn't listed
  //   const multiplier = currencyMultiplier[currency] || 100;

  //   // Calculate the base price
  //   const basePrice = Math.round(parseFloat(grandTotal) * multiplier);

  //   const options = {
  //     key: "rzp_test_a1W3Z5aa9i331A",
  //     amount: basePrice,
  //     currency: currency,
  //     name: "GCC Law Help",
  //     description: `Purchase ${planName}`,
  //     image: toAbsoluteUrl("media/img/logo/main-logo.svg"),
  //     handler: function (response) {
  //       console.log(response, "-dhddyhdjddydyuyduyuuydy");

  //       if (response.razorpay_payment_id) {
  //         addPlanPurchase(
  //           response.razorpay_payment_id,
  //           planbillingId,
  //           subTotal,
  //           currency,
  //           paymentMode,
  //           gst,
  //           grandTotal,
  //           promoCode,
  //           promoCodeType,
  //           discount,
  //           planType
  //         );
  //       }
  //     },
  //     prefill: {
  //       name: "John Doe",
  //       email: "john.doe@example.com",
  //     },
  //     notes: {
  //       address: "Your Company Address",
  //     },
  //     theme: {
  //       color: "#F37254",
  //     },
  //   };

  //   const rzp = new window.Razorpay(options);
  //   console.log(
  //     "rzp",
  //     rzp.on((data) => {
  //       return data;
  //     })
  //   );

  //   // Listen for the 'payment.cancelled' event when the modal is closed
  //   rzp.on("payment.cancelled", function (response) {
  //     console.log("cancled", response);
  //     sessionStorage.setItem("paymentstatus", "cancel");
  //     window.location.href = "/paymentstatus";

  //     sessionStorage.setItem("paymentstatus", "cancel");
  //     window.location.href = "/gcclawhelp/paymentstatus";

  //     // navigate("/paymentstatus", {
  //     //   state: {
  //     //     paymentStatus: "cancel",
  //     //   },
  //     // });
  //   });

  //   rzp.on("payment.failed", function (response) {
  //     console.log("failed", response);

  //     // navigate("/paymentstatus", {
  //     //   state: {
  //     //     paymentStatus: "failed",
  //     //   },
  //     // });
  //     sessionStorage.setItem("paymentstatus", "failed");
  //     window.location.href = "/gcclawhelp/paymentstatus";
  //   });

  //   rzp.open();
  // };

  // useEffect(() => {
  //   viewPlanDetail(planbillingId, planType, "", currency);
  // }, [planbillingId, planType, currency]);

  // Promocode Form Submit Function
  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent form submission
    // viewPlanDetail(planbillingId, planType, promoCode, currency);
  };

  // Opem Modal Popup Form Function
  const openModal = () => {
    if (promoCodeList.length == 0) {
      toasterrormsg("Promo Code Not Available!");
    } else if (promoCodeList.length > 0) {
      document.body.style.overflowY = "hidden";
      setIsModalOpen(true);
    }
  };
  // Close Modal Popup Form Function
  const closeModal = () => {
    document.body.style.overflowY = "";
    setIsModalOpen(false);
  };

  return (
    <>
      <ToastContainer />
      {isModalOpen === true && (
        <>
          <div
            onClick={closeModal}
            className={`w-full fixed top-0 z-[9999] h-screen overflow-x-hidden overflow-y-auto bg-form getintouch`}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="w-[90%] h-[95vh] overflow-y-auto md:w-[80%] lg:w-[70%] xl:w-[60%]  xxl:container p-[2%] mx-auto relative top-1/2 transform -translate-y-1/2 form-box"
            >
              <div className="flex items-center justify-between">
                <h1 className="mb-[3%] hanson">Available promo code</h1>
                <IoClose
                  onClick={closeModal}
                  className="w-[3rem] h-[3rem] cursor-pointer"
                />
              </div>
              <div className="w-full flex flex-col gap-4">
                {promoCodeList.length > 0 &&
                  promoCodeList.map((data) => (
                    <div className="flex items-center justify-between">
                      <div>
                        <h1 className="promocode-text">{data.promoCode}</h1>
                        <h2 className="promocode-off-text">{data.title}</h2>
                      </div>
                      <button
                        className="btn btn-sm btn-light-info ms-3 table-doc-icon btn-copy-text"
                        title="Copy"
                        onClick={() => {
                          navigator.clipboard.writeText(data.promoCode);
                          toastsuccessmsg("Promo Code Copied.");
                        }}
                      >
                        {/* <MdContentCopy className="fs-3" /> */}
                        Copy
                      </button>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </>
      )}
      <div className="w-full p-[3%] billing-address-main">
        <div className="xxl:container mx-auto">
          <div className="w-full flex items-center justify-center lg:justify-start mb-[2%] bam-status">
            <div className="w-max bams-box">
              <div className="w-auto mx-auto mb-[10%] flex items-center justify-center px-[2%] py-[5%] text-center no">
                <h1>1</h1>
              </div>
              <div className="title">Address</div>
            </div>
            <div className="w-[50%] sm:w-[25%] md:w-[30%] lg:w-[15%] xl:w-[10%] mt-[-5%] md:mt-[-2%] bams-box-line"></div>
            <div className="w-max bams-box bams-box2">
              <div className="w-auto mx-auto mb-[5%] flex items-center justify-center px-[2%] py-[5%] text-center no">
                <h1>2</h1>
              </div>
              <div className="title">Payment</div>
            </div>
          </div>
          <div className="w-full flex flex-col lg:flex-row gap-10 choose-payment-mode">
            <div className="flex flex-col gap-10 w-full lg:w-[70%] h-max cpm-main">
              <div className="w-full p-[3%] sm:p-[2%] cpm-part">
                <div className="w-full mb-[1%] flex items-center justify-between cpmp">
                  <h1>Choose payment mode</h1>
                </div>
                <div className="w-full px-[2%] md:px-[1%] py-[2%] ba-box">
                  <div className="w-full mb-[5%] flex gap-[5%] md:gap-[10%] lg:gap-[5%] xl:gap-[10%] cpm-types">
                    {/* <Link
                      className={`p-[1%] text-center cpm-type ${
                        paymentMode == "Online" ? "cpm-type-active" : ""
                      }`}
                      onClick={() => setPaymentMode("Online")}
                    >
                      Online Payment
                    </Link> */}
                    <Link
                      className={`p-[1%] text-center cpm-type ${
                        paymentMode == "Online" ? "cpm-type-active" : ""
                      }`}
                      onClick={() => setPaymentMode("Online")}
                    >
                      NEFT / Online
                    </Link>
                    {/* <Link
                      className={`p-[1%] text-center cpm-type ${
                        paymentMode == "COD" ? "cpm-type-active" : ""
                      }`}
                      onClick={() => setPaymentMode("COD")}
                    >
                      Cash on delivery
                    </Link> */}
                    <Link
                      className={`p-[1%] text-center cpm-type ${
                        paymentMode == "Cheque/Demand Draft"
                          ? "cpm-type-active"
                          : ""
                      }`}
                      onClick={() => setPaymentMode("Cheque/Demand Draft")}
                    >
                      Cheque / Demand draft
                    </Link>
                  </div>
                  {paymentMode == "Online" && (
                    <>
                      <div className="w-full mb-[5%]">
                        <img
                          className="w-[30%] md:w-[20%]"
                          src={toAbsoluteUrl("media/img/payment/Razorpay.svg")}
                          alt=""
                        />
                      </div>
                      <div className="w-full pay-btn">
                        <button
                          // onClick={() =>
                          //   openCheckout(
                          //     planDetail &&
                          //       planDetail.item &&
                          //       planDetail.item.name,
                          //     planDetail &&
                          //       planDetail.paymentDetail &&
                          //       planDetail.paymentDetail.subTotal.toFixed(2),
                          //     planbillingId,
                          //     currency,
                          //     paymentMode,
                          //     planDetail &&
                          //       planDetail.paymentDetail &&
                          //       planDetail.paymentDetail.GST.toFixed(2),
                          //     planDetail &&
                          //       planDetail.paymentDetail &&
                          //       planDetail.paymentDetail.grandTotal.toFixed(2),
                          //     planDetail &&
                          //       planDetail.promoCodeDetail &&
                          //       planDetail.promoCodeDetail.promoCode,
                          //     planDetail &&
                          //       planDetail.promoCodeDetail &&
                          //       planDetail.promoCodeDetail.promoCodeType,
                          //     planDetail &&
                          //       planDetail.paymentDetail &&
                          //       planDetail.paymentDetail.discount &&
                          //       planDetail.paymentDetail.discount.toFixed(2),
                          //     planType
                          //   )
                          // }
                          className="px-[3%] py-[2%] btn-pay"
                        >
                          {/* Pay Now {currencySymbol} */}
                          Pay now {currency}{" "}
                          {planDetail &&
                            planDetail.paymentDetail &&
                            planDetail.paymentDetail.grandTotal.toFixed(2)}
                        </button>
                      </div>
                    </>
                  )}
                  {/* {paymentMode == "cheque" && (
                    <div>
                      <form onSubmit={formik.handleSubmit}>
                        <div className="w-full mb-[2rem]">
                          <div className="w-full flex flex-col">
                            <label
                              htmlFor=""
                              className="w-full form-input-label required mb-4"
                            >
                              Cheque Number
                            </label>
                            <input
                              type="text"
                              className="w-full px-[3%] py-[2%] pcpi"
                              placeholder="Enter Cheque Number"
                              id="cheque"
                              name="cheque"
                              value={formik.values.cheque}
                              onChange={formik.handleChange}
                            />
                            {formik.touched.cheque && formik.errors.cheque && (
                              <div className="mt-2 error-msg2">
                                <div className="">{formik.errors.cheque}</div>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="w-full pay-btn">
                          <button
                            type="submit"
                            className="px-[3%] py-[2%] btn-pay"
                          >
                            Submit
                          </button>
                        </div>
                      </form>
                    </div>
                  )} */}
                </div>
              </div>
              <div className="w-full p-[3%] sm:p-[2%] promo-code-part cpm-part">
                <div className="w-full mb-[1%] flex items-center justify-between pcp">
                  <h1>Have a promo code?</h1>
                </div>
                <form action="" onSubmit={handleSubmit} className="mb-[1%]">
                  <div className="w-full flex gap-2 sm:gap-5 md:gap-10 ">
                    <div className="w-[85%] pcp-input">
                      <input
                        type="text"
                        className="w-full px-[3%] py-[2%] pcpi"
                        placeholder="Enter Code"
                        value={promoCode}
                        onChange={(e) => setPromoCode(e.target.value)}
                      />
                    </div>
                    <div className="w-[15%] pay-btn">
                      <button
                        type="submit"
                        onClick={() => setPromoCode}
                        className="w-full h-full btn-pay"
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                </form>

                <button onClick={() => openModal()} className="btn-link">
                  Available promo code
                </button>
                <div className="mt-2 error-msg">
                  <div className="">{isPromoCodeValid && isPromoCodeValid}</div>
                </div>
              </div>
            </div>
            <div className="w-[90%] h-max sm:w-[60%] lg:w-[30%] mx-auto p-[3%] sm:px-[2%] sm:py-[2.5%] lg:px-[1%] lg:py-[1.5%] cart-summary">
              <h1 className="w-full mb-[2%] cs-h1">Cart summary</h1>
              <div className="w-full flex flex-col justify-between">
                <div className="w-full px-[3%] mb-[40%] py-[3.5%] cs-box1">
                  <div className="w-full">
                    <h1 className="mb-[1%]">
                      {planDetail && planDetail.item && planDetail.item.name}
                    </h1>
                    <h2 className="mb-[5%]">
                      {" "}
                      {/* {currencySymbol} */}
                      {currency}{" "}
                      {planDetail &&
                        planDetail.item &&
                        planDetail.item.price.toFixed(2)}{" "}
                      / Combo
                    </h2>
                    <div className="flex justify-between items-center gap-10">
                      <div className="flex items-center gap-10 csb1">
                        {/* <CiCirclePlus className="cursor-pointer csb1-icon" /> */}
                        <h3 className="csb1-no">Quantity : 1</h3>
                        {/* <CiCircleMinus className="cursor-pointer csb1-icon" /> */}
                      </div>
                      <div className="flex items-center gap-10 csb1p2">
                        <h3 className="csb1p2-price">
                          {/* Price: {currencySymbol} */}
                          Price: {currency}{" "}
                          {planDetail &&
                            planDetail.item &&
                            planDetail.item.price.toFixed(2)}
                          /-
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="w-full flex flex-col items-between cs-box2">
                  <div className="mb-auto">
                    <div className="w-full flex items-center justify-between mb-[5%] gap-5 csb2">
                      <h1 className="w-[60%] sm:w-[50%] md:w-[40%] lg:w-[90%] xl:w-[57%] csb2-title">
                        Payment details
                      </h1>
                      <div className="w-full csb2-line"></div>
                    </div>
                    <div className="w-full mb-[2%] payment-details">
                      <div className="w-full flex justify-between pd-item">
                        <h1 className="w-max">Item</h1>
                        <h2 className="w-max">
                          {planDetail &&
                            planDetail.paymentDetail &&
                            planDetail.paymentDetail.item}
                        </h2>
                      </div>
                    </div>
                    <div className="w-full mb-[2%] payment-details">
                      <div className="w-full flex justify-between pd-item">
                        <h1 className="w-max">Subtotal</h1>
                        <h2 className="w-max">
                          {/* {currencySymbol} */}
                          {currency}{" "}
                          {planDetail &&
                            planDetail.paymentDetail &&
                            planDetail.paymentDetail.subTotal.toFixed(2)}
                          /-
                        </h2>
                      </div>
                    </div>
                    <div className="w-full mb-[2%] payment-details">
                      <div className="w-full flex justify-between pd-item">
                        <h1 className="w-max">GST @ 18%</h1>
                        <h2 className="w-max">
                          {/* {currencySymbol} */}
                          {currency}{" "}
                          {planDetail &&
                            planDetail.paymentDetail &&
                            planDetail.paymentDetail.GST.toFixed(2)}
                          /-
                        </h2>
                      </div>
                    </div>
                    {planDetail &&
                      planDetail.paymentDetail &&
                      planDetail.paymentDetail.discount && (
                        <div className="w-full mb-[2%] payment-details">
                          <div className="w-full flex justify-between pd-item">
                            <h1 className="w-max">Discount</h1>
                            <h2 className="w-max">
                              {/* {currencySymbol} */}
                              {currency}{" "}
                              {planDetail.paymentDetail.discount.toFixed(2)}
                              /-
                            </h2>
                          </div>
                        </div>
                      )}
                    <div className="w-full payment-details">
                      <div className="w-full flex justify-between pd-item pd-item2">
                        <h1 className="w-max">Grand total</h1>
                        <h2 className="w-max">
                          {/* {currencySymbol} */}
                          {currency}{" "}
                          {planDetail &&
                            planDetail.paymentDetail &&
                            planDetail.paymentDetail.grandTotal.toFixed(2)}
                          /-
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>
                {paymentMode != "Online" && (
                  <div className="w-full mt-[5%] flex pay-button">
                    {/* <button
                      onClick={() => {
                        addPlanPurchase(
                          "",
                          planbillingId,
                          planDetail &&
                            planDetail.item &&
                            planDetail.item.price.toFixed(2),
                          currency,
                          paymentMode,
                          planDetail &&
                            planDetail.paymentDetail &&
                            planDetail.paymentDetail.GST.toFixed(2),
                          planDetail &&
                            planDetail.paymentDetail &&
                            planDetail.paymentDetail.grandTotal.toFixed(2),
                          promoCode,
                          planDetail &&
                            planDetail.promoCodeDetail &&
                            planDetail.promoCodeDetail.promoCodeType,
                          planDetail &&
                            planDetail.paymentDetail &&
                            planDetail.paymentDetail.discount &&
                            planDetail.paymentDetail.discount.toFixed(2)
                        );
                      }}
                      className="w-full py-[5%] btn-pay"
                    >
                      Process to Pay {currency}{" "}
                      {planDetail &&
                        planDetail.paymentDetail &&
                        planDetail.paymentDetail.grandTotal.toFixed(2)}
                    </button> */}
                    <button
                      className="w-full py-[5%] btn-pay"
                      onClick={() => {
                        addPlanPurchase(
                          "",
                          planbillingId,
                          planDetail &&
                            planDetail.item &&
                            planDetail.item.price.toFixed(2),
                          currency,
                          paymentMode,
                          planDetail &&
                            planDetail.paymentDetail &&
                            planDetail.paymentDetail.GST.toFixed(2),
                          planDetail &&
                            planDetail.paymentDetail &&
                            planDetail.paymentDetail.grandTotal.toFixed(2),
                          promoCode,
                          planDetail &&
                            planDetail.promoCodeDetail &&
                            planDetail.promoCodeDetail.promoCodeType,
                          planDetail &&
                            planDetail.paymentDetail &&
                            planDetail.paymentDetail.discount &&
                            planDetail.paymentDetail.discount.toFixed(2),
                          planType
                        );
                      }}
                      disabled={loading}
                    >
                      {!loading && (
                        <>
                          {" "}
                          Process to pay {currency}{" "}
                          {planDetail &&
                            planDetail.paymentDetail &&
                            planDetail.paymentDetail.grandTotal.toFixed(2)}
                        </>
                      )}
                      {loading && (
                        <div className="flex items-center justify-center gap-3">
                          <span className="" style={{ display: "block" }}>
                            Please wait...{" "}
                          </span>
                          <ClipLoader
                            color={"#ffffff"}
                            loading={loading}
                            size={20}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                          />
                        </div>
                      )}
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChoosePaymentReadyReferenceTwo;
